import {DefaultPCS} from './render.def';
import s from '../s';
import {isNullOrWhiteSpace, Portal} from '../../util';

export const prerender_set_pcs = () => {
    if (!s.prod) {
        return;
    }

    // moulding set
    const moulding = s.prod.mouldings.filter(m => m.id === s.ps.moulding_id)[0];
    if (moulding) {
        s.pcs.MouldingID = moulding.id;
        s.pcs.MouldingName = moulding.name;
        s.pcs.MouldingExtWidth = moulding.extWidth;
    }

    // doc 2 set
    if (s.prod.DocumentID2 > 0) {
        s.pcs.DocumentID2 = s.prod.DocumentID2;
        s.pcs.Base_DocumentName2 = s.prod.DocumentName2;
    }

    // mats set
    if (!s.pcs.IsCAF) {
        const mat = s.prod.mats.filter(m => m.id === s.ps.matcombo_id)[0];
        if (mat) {
            s.pcs.MatCombo_IsWoodFillet = mat.mat2_id === 36 || mat.mat2_id === 38;
            s.pcs.PrimaryMatID = mat.mat1_id;
            s.pcs.PrimaryMatName = mat.pmat_name;
            s.pcs.PrimaryMatColor = mat.pmat_color;
            s.pcs.SecondaryMatID = mat.mat2_id;
            if (s.pcs.SecondaryMatID > 0) {
                s.pcs.SecondaryMatName = mat.smat_name;
                s.pcs.SecondaryMatColor = mat.smat_color;
            }
        }
    } else {
        const mat1 = s.prod.caf_mat1.filter(m => m.id === s.ps.mat1_id)[0];
        const mat2 = s.prod.caf_mat2.filter(m => m.id === s.ps.mat2_id)[0];
        if (mat1) {
            s.pcs.PrimaryMatID = mat1.id;
            s.pcs.PrimaryMatName = mat1.name;
            s.pcs.PrimaryMatColor = mat1.mat_color;
        } else {
            s.pcs.PrimaryMatID = -1;
            s.pcs.PrimaryMatName = '';
            s.pcs.PrimaryMatColor = '';
        }
        if (mat2) {
            s.pcs.MatCombo_IsWoodFillet = mat2.id === 36 || mat2.id === 38;
            s.pcs.SecondaryMatID = mat2.id;
            s.pcs.SecondaryMatName = mat2.name;
            s.pcs.SecondaryMatColor = mat2.mat_color;
        } else {
            s.pcs.SecondaryMatID = -1;
            s.pcs.SecondaryMatName = '';
            s.pcs.SecondaryMatColor = '';
        }
    }

    if (s.prod.EngravedPlateStatusID === 0) {
        s.pcs.HasEngravedPlate = false;
        s.ps.ep_id = -1;
    }

    s.pcs.DYF_FrameStyleID = s.prod.DYF_FrameStyleID;

    s.pcs.Base_ExtraID = s.prod.ExtraEntityID;
    s.pcs.Base_ExtraEntityName = s.prod.ExtraEntityName;

    s.pcs.state_FlatImageMode = true;
    if (window.innerWidth > 1200) {
        s.pcs.MaxFrameWidthPx = DefaultPCS.DefaultMaxFrameWidth;
    } else if (window.innerWidth > 880) {
        s.pcs.MaxFrameWidthPx = 800;
    } else if (window.innerWidth > 440) {
        s.pcs.MaxFrameWidthPx = window.innerWidth * 0.9;
    } else if (window.innerWidth > 200) {
        s.pcs.MaxFrameWidthPx = window.innerWidth * 0.85;
    } else {
        s.pcs.MaxFrameWidthPx = window.innerWidth * 0.75;
    }
    s.pcs.MaxFrameHeightPx = DefaultPCS.DefaultMaxFrameHeight;

    s.pcs.css.insignia_bot_visible = false;
    s.pcs.Document_Width = s.ps.docWidth;
    s.pcs.Document_Height = s.ps.docHeight;
    s.pcs.Document2_Width = s.ps.docWidth2;
    s.pcs.Document2_Height = s.ps.docHeight2;

    if (s.pcs.DYF_FrameStyleID === 2 && !s.pcs.IsCAF && s.pcs.Document2_Width !== s.pcs.Document_Width && s.pcs.Document2_Width > 0) {
        s.pcs.isHorizontal = s.prod.IsHorizontal;
    } else {
        s.pcs.isHorizontal = s.ps.docWidth > s.ps.docHeight;
    }

    if (!s.ps.ep_id || s.ps.ep_id <= 0) {
        s.pcs.HasEngravedPlate = false;
    } else {
        s.pcs.HasEngravedPlate = true;
        s.pcs.EngravedPlateID = s.ps.ep_id;
        if (s.ps.ep_id === 37) {
            s.pcs.EngravedPlateName = 'EP_Gold';
        } else if (s.ps.ep_id === 39) {
            s.pcs.EngravedPlateName = 'EP_Silver';
        } else if (s.ps.ep_id === 33146) {
            s.pcs.EngravedPlateName = 'EP_White';
        } else {
            s.pcs.EngravedPlateName = 'EP_Black';
        }
        s.pcs.EP_1 = s.ps.ep1;
        s.pcs.EP_2 = s.ps.ep2;
        s.pcs.EP_3 = s.ps.ep3;
        s.pcs.EP_4 = s.ps.ep4;
        s.pcs.EP_5 = s.ps.ep5;
        s.pcs.EP_6 = s.ps.ep6;
        s.pcs.EP_7 = s.ps.ep7;
        s.pcs.EP_8 = s.ps.ep8;
        s.pcs.EP_9 = s.ps.ep9;
        s.pcs.EP_10 = s.ps.ep10;
    }

    s.pcs.Base_LinoID = s.ps.lino_id;
    s.pcs.Base_LinoName = s.ps.lino_base_name;
    s.pcs.lino_dyf_color = s.ps.lino_dyf_color;
    s.pcs.Base_InsigniaID = s.ps.insignia_id;
    s.pcs.Base_InsigniaName = s.ps.insignia_base_name;

    if (s.pcs.allowUpload1 && s.ui.image_uploaded && s.ps.override_d1_img && s.ps.override_d1_img.length > 5) {
        s.pcs.o3 = s.ps.override_d1_img;
    }

    s.pcs.CustomizationMethodID = s.prod.CustomizationMethod;
    s.pcs.allowUpload1 = s.prod.allowUpload1;
    s.pcs.allowUpload2 = s.prod.allowUpload2;
    s.pcs.ProductID = s.prod.ProductID;
    s.pcs.ADA = GetADA();
    s.pcs.th6Enabled = !s.prod.th6Disabled && !isNullOrWhiteSpace(s.prod.th6);
    s.pcs.IsDefaultConfig = isDefaultConfig();
    s.pcs.ProductName_Original = s.prod.Name;
    s.pcs.PortalID = Portal?.PortalID as number;
    s.pcs.ProductTypeID = s.prod.ProductTypeID;
    s.pcs.VL_BG_Color = s.ps.vlbg_color;
    s.pcs.CDNDomain = Portal?.CDNDomain as string;
    s.pcs.FramePartDomain = `https://${Portal?.CDNDomain}/images/entities/`;
    s.pcs.JF_Width = s.prod.JF_Width;
    s.pcs.JF_Height = s.prod.JF_Height;
    s.pcs.MouldingThickness = s.prod.MouldingThickness;
    s.pcs.lino_is_dyf = s.ps.lino_is_dyf;
    s.pcs.image_uploaded = s.ui.image_uploaded;
    s.pcs.old_style_composite = s.ui.old_style_composite;
    s.pcs.Image_Full = s.prod.Image_Full;

    s.pcs.EP_1 = s.ps.ep1;
    s.pcs.EP_2 = s.ps.ep2;
    s.pcs.EP_3 = s.ps.ep3;
    s.pcs.EP_4 = s.ps.ep4;
    s.pcs.EP_5 = s.ps.ep5;
    s.pcs.EP_6 = s.ps.ep6;
    s.pcs.EP_7 = s.ps.ep7;
    s.pcs.EP_8 = s.ps.ep8;
    s.pcs.EP_9 = s.ps.ep9;
    s.pcs.EP_10 = s.ps.ep10;
};

const GetADA = (): string => {
    if (!s.si && !s.prod) {
        return 'Diploma Frame';
    }

    let ada = `${s.si ? s.si.InstName : ''} ${Portal && Portal?.PortalID < 1 ? `Diploma` : `Document`} Frame`;
    if (s.ps.moulding_id > 0) {
        ada += ` in ${s.ui.title_moulding}`;
    }

    if (!s.prod.IsFrame) {
        ada = s.prod.Name;
    } else if (s.prod.CustomizationMethod < 2) {
        if (s.prod.Mat1_ID > 0) {
            ada += ` with ${s.prod.MatComboName} matting`;
        }

        if (s.prod.InsigniaID > 0) {
            ada += `, and a ${s.prod.InsigniaDisplayName}`;
        }
        ada += '.';
    } else {
        if (s.ps.mat1_id > 0 || s.ps.mat2_id > 0) {
            ada += ` with ${s.ui.title_mat_combo} matting`;
        }

        if (s.ps.insignia_id > 0) {
            ada += `, and a ${s.ui.title_insignia ? s.ui.title_insignia : s.prod.InsigniaDisplayName}`;
        }
        ada += '.';
    }
    return ada.trim();
};

const isDefaultConfig = (): boolean => {
    return s.prod.MouldingID === s.ps.moulding_id && s.prod.Mat1_ID === s.ps.mat1_id && s.prod.Mat2_ID === s.ps.mat2_id && s.prod.InsigniaID === s.ps.insignia_id && s.prod.EngravedPlateStatusID === s.ps.ep_id && s.prod.LinoID === s.ps.lino_id;
};
